const FOCUS_BORDER_WIDTH = "2px";
const ZINDEX_SELECT_LIST = 20;
const ZINDEX_SELECT_INPUT_FOCUSED = 30;
const ZINDEX_SELECT_LIST_FULLSCREEN = 100000;

export { FOCUS_BORDER_WIDTH, ZINDEX_SELECT_INPUT_FOCUSED, ZINDEX_SELECT_LIST, ZINDEX_SELECT_LIST_FULLSCREEN };
//# sourceMappingURL=constants.js.map
